// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template {
  padding: 40px;
  margin: 10px 10px 10px 10px;
  padding: 0 20px 20px 20px;
  border-radius: 15px;
  display: block;
  position: relative;
  align-items: stretch;
  min-height: 100px;
}
.template .border {
  border-bottom: 1px solid #e3e2df;
}
.template .border p {
  margin-bottom: 10px;
  text-align: justify;
}

h1 {
  margin: 40px 40px 0 50px;
}

h2 {
  margin: 20px 0 10px 0;
}

a {
  color: #000;
}
a span {
  color: #606060;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: 20px;
  margin-left: 20px;
}
.row .col-sm {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
.row .col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.align {
  float: right;
}

.active {
  color: #FF4612;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByaXZhY3ktcG9saWN5LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUdBLDJCQUFBO0VBQ0EseUJBQUE7RUFFQSxtQkFBQTtFQUNBLGNBQUE7RUFDQSxrQkFBQTtFQUNBLG9CQUFBO0VBQ0EsaUJBQUE7QUFURjtBQVdFO0VBQ0UsZ0NBQUE7QUFDSjtBQUNJO0VBQ0UsbUJBQUE7RUFDQSxtQkFBQTtBQUNOOztBQUlBO0VBQ0Usd0JBQUE7QUFERjs7QUFJQTtFQUNFLHFCQUFBO0FBREY7O0FBSUE7RUFDRSxXQUFBO0FBREY7QUFFRTtFQUNFLGNBQUE7QUFBSjs7QUFJQTtFQUNFLGFBQUE7RUFDQSxlQUFBO0VBQ0Esa0JBQUE7RUFDQSxpQkFBQTtBQURGO0FBR0E7RUFDRSxhQUFBO0VBR0UsWUFBQTtFQUNBLGVBQUE7QUFESjtBQUlBO0VBR0UsYUFBQTtFQUNBLGNBQUE7QUFGRjs7QUFNQTtFQUNFLFlBQUE7QUFIRjs7QUFNQTtFQUNFLGNBQUE7QUFIRiIsImZpbGUiOiJwcml2YWN5LXBvbGljeS5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi50ZW1wbGF0ZSB7XG4gIHBhZGRpbmc6IDQwcHg7XG59XG4udGVtcGxhdGUge1xuICBtYXJnaW46IDEwcHggMTBweCAxMHB4IDEwcHg7XG4gIHBhZGRpbmc6IDAgMjBweCAyMHB4IDIwcHg7XG4gIC8vIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG4gIGJvcmRlci1yYWRpdXM6IDE1cHg7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGFsaWduLWl0ZW1zOiBzdHJldGNoO1xuICBtaW4taGVpZ2h0OiAxMDBweDtcblxuICAuYm9yZGVye1xuICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjZTNlMmRmO1xuXG4gICAgcHtcbiAgICAgIG1hcmdpbi1ib3R0b206IDEwcHg7XG4gICAgICB0ZXh0LWFsaWduOiBqdXN0aWZ5O1xuICAgIH1cbiAgfVxufVxuXG5oMXtcbiAgbWFyZ2luOiA0MHB4IDQwcHggMCA1MHB4O1xufVxuXG5oMntcbiAgbWFyZ2luOiAyMHB4IDAgMTBweCAwO1xufVxuXG5he1xuICBjb2xvcjogIzAwMDtcbiAgc3BhbiB7XG4gICAgY29sb3I6ICM2MDYwNjA7XG4gIH1cbn1cblxuLnJvd3tcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC13cmFwOiB3cmFwO1xuICBtYXJnaW4tcmlnaHQ6IDIwcHg7XG4gIG1hcmdpbi1sZWZ0OiAyMHB4O1xuXG4uY29sLXNte1xuICBmbGV4LWJhc2lzOiAwO1xuICAgIC13ZWJraXQtYm94LWZsZXg6IDE7XG4gICAgLW1zLWZsZXgtcG9zaXRpdmU6IDE7XG4gICAgZmxleC1ncm93OiAxO1xuICAgIG1heC13aWR0aDogMTAwJTtcbn1cblxuLmNvbC02e1xuICAtd2Via2l0LWJveC1mbGV4OiAwO1xuICAtbXMtZmxleDogMCAwIDUwJTtcbiAgZmxleDogMCAwIDUwJTtcbiAgbWF4LXdpZHRoOiA1MCU7XG59XG59XG5cbi5hbGlnbntcbiAgZmxvYXQ6IHJpZ2h0O1xufVxuXG4uYWN0aXZle1xuICBjb2xvcjogI0ZGNDYxMjtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/containers/static-resources/privacy-policy/privacy-policy.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EAGA,2BAAA;EACA,yBAAA;EAEA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;AATF;AAWE;EACE,gCAAA;AACJ;AACI;EACE,mBAAA;EACA,mBAAA;AACN;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,WAAA;AADF;AAEE;EACE,cAAA;AAAJ;;AAIA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AADF;AAGA;EACE,aAAA;EAGE,YAAA;EACA,eAAA;AADJ;AAIA;EAGE,aAAA;EACA,cAAA;AAFF;;AAMA;EACE,YAAA;AAHF;;AAMA;EACE,cAAA;AAHF;AANA,g8DAAg8D","sourcesContent":[".template {\n  padding: 40px;\n}\n.template {\n  margin: 10px 10px 10px 10px;\n  padding: 0 20px 20px 20px;\n  // background-color: #fff;\n  border-radius: 15px;\n  display: block;\n  position: relative;\n  align-items: stretch;\n  min-height: 100px;\n\n  .border{\n    border-bottom: 1px solid #e3e2df;\n\n    p{\n      margin-bottom: 10px;\n      text-align: justify;\n    }\n  }\n}\n\nh1{\n  margin: 40px 40px 0 50px;\n}\n\nh2{\n  margin: 20px 0 10px 0;\n}\n\na{\n  color: #000;\n  span {\n    color: #606060;\n  }\n}\n\n.row{\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: 20px;\n  margin-left: 20px;\n\n.col-sm{\n  flex-basis: 0;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n}\n\n.col-6{\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 50%;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n}\n\n.align{\n  float: right;\n}\n\n.active{\n  color: #FF4612;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
